import { UserInteractionRequirement } from "@/components/Checkout/types";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { Retailer } from "@/redux/types";
import { OTPPopup } from "./OTP";

type DialogState = {
  open: boolean;
  retailer?: Retailer;
  userInteractionRequirement?: UserInteractionRequirement;
  onSave: (otp: string) => void;
  onResend: () => void;
};

const defaultState: DialogState = {
  open: false,
  retailer: undefined,
  userInteractionRequirement: undefined,
  onSave: () => {},
  onResend: () => {},
};

const useDialogStore = create<
  DialogState & {
    show: (props: Omit<DialogState, "open">) => void;
    close: () => void;
  }
>((set) => ({
  ...defaultState,
  show: (props) => set({ ...defaultState, ...props, open: true }),
  close: () => set({ ...defaultState }),
}));

const OTPDialog = () => {
  const {
    open,
    retailer,
    userInteractionRequirement,
    onSave,
    onResend,
    close,
  } = useDialogStore();

  const [otp, setOtp] = useState("");
  const [resendCoolDown, setResendCoolDown] = useState(0);

  useEffect(() => {
    if (resendCoolDown > 0) {
      const timer = setTimeout(
        () => setResendCoolDown(resendCoolDown - 1),
        1000
      );
      return () => clearTimeout(timer);
    }
  }, [resendCoolDown]);

  const handleResend = () => {
    if (resendCoolDown > 0) return;
    setResendCoolDown(30);
    onResend();
  };

  return (
    <OTPPopup
      open={open}
      onClose={() => {
        setOtp("");
        setResendCoolDown(0);
        close();
      }}
      value={otp}
      onChange={setOtp}
      onSave={() => {
        onSave(otp);
        setOtp("");
        close();
      }}
      retailer={retailer}
      onResend={handleResend}
      resendCoolDown={resendCoolDown}
      userInteractionRequirement={userInteractionRequirement}
    />
  );
};

OTPDialog.show = (props: Omit<DialogState, "open">) => {
  useDialogStore.getState().show(props);
};

OTPDialog.close = () => {
  useDialogStore.getState().close();
};

export default OTPDialog;
